export const CloudflareActionTypes = {
  DOMAINS_REQUEST: 'CLOUDFLARE_DOMAINS_REQUEST',
  DOMAINS_FAILURE: 'CLOUDFLARE_DOMAINS_FAILURE',
  DOMAINS_SUCCESS: 'CLOUDFLARE_DOMAINS_SUCCESS',
  RESET_ACTIVATED_DOMAIN_STATUS: 'CLOUDFLARE_RESET_ACTIVATED_DOMAIN_STATUS',
  DOMAINS_SET: 'CLOUDFLARE_DOMAINS_SET',
  DOMAINS_LOADING: 'CLOUDFLARE_DOMAINS_LOADING',
  DOMAINS_ERROR: 'CLOUDFLARE_DOMAINS_ERROR',

  ACTIVE_DOMAINS_REQUEST: 'CLOUDFLARE_ACTIVE_DOMAINS_REQUEST',
  ACTIVE_DOMAINS_SUCCESS: 'CLOUDFLARE_ACTIVE_DOMAINS_SUCCESS',
  ACTIVE_DOMAINS_FAILURE: 'CLOUDFLARE_ACTIVE_DOMAINS_FAILURE',
  ACTIVE_DOMAINS_RESET_STATUS: 'CLOUDFLARE_ACTIVE_DOMAINS_RESET_STATUS',
  SET_ACTIVE_DOMAINS: 'CLOUDFLARE_SET_ACTIVE_DOMAINS',
  ACTIVE_DOMAINS_REQUEST_LOADING: 'CLOUDFLARE_ACTIVE_DOMAINS_REQUEST_LOADING',

  STATUS_OF_FEATURES_REQUEST: 'CLOUDFLARE_STATUS_OF_FEATURES_REQUEST',
  STATUS_OF_FEATURES_SUCCESS: 'CLOUDFLARE_STATUS_OF_FEATURES_SUCCESS',
  STATUS_OF_FEATURES_FAILURE: 'CLOUDFLARE_STATUS_OF_FEATURES_FAILURE',
  STATUS_OF_FEATURES_RESET_REQUEST_STATUS: 'CLOUDFLARE_STATUS_OF_FEATURES_RESET_REQUEST_STATUS',
  SET_STATUS_OF_FEATURES: 'CLOUDFLARE_SET_STATUS_OF_FEATURES',
  STATUS_OF_FEATURES_LOADING: 'CLOUDFLARE_STATUS_OF_FEATURES_LOADING',

  UPDATE_FEATURE_REQUEST: 'CLOUDFLARE_UPDATE_FEATURE_REQUEST',
  UPDATE_FEATURE_SUCCESS: 'CLOUDFLARE_UPDATE_FEATURE_SUCCESS',
  UPDATE_FEATURE_FAILURE: 'CLOUDFLARE_UPDATE_FEATURE_FAILURE',
  UPDATE_FEATURE_LOADING: 'CLOUDFLARE_UPDATE_FEATURE_LOADING',
  SET_UPDATE_FEATURE: 'CLOUDFLARE_SET_UPDATE_FEATURE',
  RESET_UPDATE_FEATURE_STATUS: 'CLOUDFLARE_RESET_UPDATE_FEATURE_STATUS',

  ACTIVATE_CDN: 'CLOUDFLARE_ACTIVATE_CDN',
  DEACTIVATE_CDN: 'CLOUDFLARE_DEACTIVATE_CDN',
  LOADING_ACTIVATION: 'CLOUDFLARE_LOADING_ACTIVATION',
  LOADING_ACTIVATION_SUCCESS: 'CLOUDFLARE_LOADING_ACTIVATION_SUCCESS',
  LOADING_ACTIVATION_FAILURE: 'CLOUDFLARE_LOADING_ACTIVATION_FAILURE',
  LOADING_DEACTIVATION_SUCCESS: 'CLOUDFLARE_LOADING_DEACTIVATION_SUCCESS',
  LOADING_DEACTIVATION_FAILURE: 'CLOUDFLARE_LOADING_DEACTIVATION_FAILURE',
  SET_ACTIVATED_DOMAIN: 'CLOUDFLARE_SET_ACTIVATED_DOMAIN',

  REQUEST_PURGE_CACHE: 'CLOUDFLARE_REQUEST_PURGE_CACHE',
  REQUEST_PURGE_CACHE_SUCCESS: 'CLOUDFLARE_REQUEST_PURGE_CACHE_SUCCESS',
  REQUEST_PURGE_CACHE_FAILURE: 'CLOUDFLARE_REQUEST_PURGE_CACHE_FAILURE',
  REQUEST_PURGE_CACHE_LOADING: 'CLOUDFLARE_REQUEST_PURGE_CACHE_LOADING',
  SET_PURGE_CACHE: 'CLOUDFLARE_SET_PURGE_CACHE',

  SITES_WIZARD_REQUEST_DOMAIN_DATA: 'SITES_WIZARD_REQUEST_DOMAIN_DATA',
  SITES_WIZARD_SET_DOMAIN_DATA: 'SITES_WIZARD_SET_DOMAIN_DATA',
  SITES_WIZARD_CLOUDFLARE_REQUEST_SUCCEEDED: 'SITES_WIZARD_CLOUDFLARE_REQUEST_SUCCEEDED',
  SITES_WIZARD_CLOUDFLARE_REQUEST_FAILED: 'SITES_WIZARD_CLOUDFLARE_REQUEST_FAILED',

  SPEED_ANALYTICS_REQUEST: 'SPEED_ANALYTICS_REQUEST',
  SPEED_ANALYTICS_GET_HISTORY: 'SPEED_ANALYTICS_GET_HISTORY',
  SPEED_ANALYTICS_GET_HISTORY_FAILED: 'SPEED_ANALYTICS_GET_HISTORY_FAILED',
  SPEED_ANALYTICS_SET_HISTORY: 'SPEED_ANALYTICS_SET_HISTORY',
  SPEED_ANALYTICS_SET_LAST_ANALYSIS_ID: 'SPEED_ANALYTICS_SET_LAST_ANALYSIS_ID',
  SPEED_ANALYTICS_SET_LAST_ANALYSIS: 'SPEED_ANALYTICS_SET_LAST_ANALYSIS',

  VISITORS_ANALYSIS_REQUEST: 'VISITORS_ANALYSIS_REQUEST',
  SET_VISITOR_ANALYSIS: 'SET_VISITOR_ANALYSIS',
  RESET_VISITOR_ANALYSIS: 'RESET_VISITOR_ANALYSIS',
  SET_VISITORS_SUCCESS: 'SET_VISITORS_SUCCESS',
  SET_VISITORS_FAILURE: 'SET_VISITORS_FAILURE',

  ANALYTICS_SUCCEEDED_REQUEST: 'ANALYTICS_SUCCEEDED_REQUEST',
  ANALYTICS_FAILED_REQUEST: 'ANALYTICS_FAILED_REQUEST',
  SET_LOADING_ANALYSIS: 'SET_LOADING_ANALYSIS',
  SPEED_LOADING_HISTORY: 'SPEED_LOADING_HISTORY',
  RESET_HISTORY_REQUEST_STATUS: 'RESET_HISTORY_REQUEST_STATUS',

  ADD_RULE_REQUEST: 'CLOUDFLARE_ADD_RULE_REQUEST',
  ADD_RULE_SUCCESS: 'CLOUDFLARE_ADD_RULE_SUCCESS',
  ADD_RULE_FAILURE: 'CLOUDFLARE_ADD_RULE_FAILURE',
  SET_ADD_RULE_LOADING: 'CLOUDFLARE_SET_ADD_RULE_LOADING',
  RESET_ADD_RULE_STATE: 'CLOUDFLARE_RESET_ADD_RULE_STATE',

  DELETE_RULE_REQUEST: 'CLOUDFLARE_DELETE_RULE_REQUEST',
  DELETE_RULE_SUCCESS: 'CLOUDFLARE_DELETE_RULE_SUCCESS',
  DELETE_RULE_LOADING: 'CLOUDFLARE_DELETE_RULE_LOADING',
  RESET_DELETE_RULE_STATE: 'CLOUDFLARE_RESET_DELETE_RULE_STATE',
  SET_DELETE_RULE_LOADING: 'CLOUDFLARE_SET_DELETE_RULE_LOADING',

  EDIT_RULE_REQUEST: 'CLOUDFLARE_EDIT_RULE_REQUEST',
  EDIT_RULE_SET: 'CLOUDFLARE_EDIT_RULE_SET',
  EDIT_RULE_LOADING: 'CLOUDFLARE_EDIT_RULE_LOADING',
  RESET_EDIT_RULE_STATE: 'CLOUDFLARE_RESET_EDIT_RULE_STATE',
  SET_SINGLE_RULE_LOADING: 'CLOUDFLARE_SET_SINGLE_RULE_LOADING',

  GET_RULES_REQUEST: 'CLOUDFLARE_GET_RULES_REQUEST',
  SET_RULES: 'CLOUDFLARE_SET_RULES',
  GET_RULES_SUCCESS: 'CLOUDFLARE_GET_RULES_SUCCESS',
  GET_RULES_FAILURE: 'CLOUDFLARE_GET_RULES_FAILURE',
  SET_RULES_LOADING: 'CLOUDFLARE_SET_RULES_LOADING',
  RESET_GET_RULES_STATUS: 'CLOUDFLARE_RESET_GET_RULES_STATUS',

  SET_RULE_FORM_DATA: 'CLOUDFLARE_SET_RULE_FORM_DATA',

  TOGGLE_RULE_STATUS_REQUEST: 'CLOUDFLARE_TOGGLE_RULE_STATUS',
  TOGGLE_RULE_STATUS_SET: 'CLOUDFLARE_TOGGLE_RULE_STATUS_SET',
  TOGGLE_RULE_STATUS_FAILURE: 'CLOUDFLARE_TOGGLE_RULE_STATUS_FAILURE',
};
